module.exports = __webpack_public_path__ + "static/kuchnia-photo03-ee67819f5bbb60ed89ac0bfef042dd2d.jpg";